<template>
  <tfoot v-if="rows.length > 0">
    <tr style="background-color: #f2f2f28e">
      <td class="text-center p-3">
        <strong style="font-size: 16px">{{
          $t('common_words.total_mayus')
        }}</strong>
      </td>
      <td class="text-center p-3">
        <strong style="font-size: 16px">{{
          getFormatNumber(getTotalArea())
        }}</strong>
      </td>
      <template v-for="(ribbon, week) in columns">
        <td class="text-center">
          <strong style="font-size: 16px">{{
            getTotalColumn(week, ribbon[0])
          }}</strong>
        </td>
        <td class="text-center">
          <strong style="font-size: 16px">{{
            getTotalColumn(week, ribbon[0], 'byLotsHa')
          }}</strong>
        </td>
        <td class="text-center">100%</td>
      </template>
    </tr>
  </tfoot>
</template>
<script>
import { getSumOfValorFromArray } from 'src/util/Util.js';
import Formatter from 'src/class/Formatter';
import MixinMasters from 'src/util/mixinMasters';
import TfootTotals from './TfootTotals.vue';

export default {
  name: 'tfoot-percent-pockets',
  components: {
    [TfootTotals.name]: TfootTotals,
  },
  props: {
    rows: {
      type: Array | Object,
      default: [],
    },
    coveredAreas: {
      type: Array | Object,
      default: [],
    },
    columns: {
      type: Array | Object,
      default: [],
    },
    totalColumns: {
      type: Array | Object,
      default: [],
    },
  },
  computed: {
    getSizeRows() {
      return Object.values(this.rows).length;
    },
  },
  mixins: [MixinMasters],
  methods: {
    getFormatNumber(value) {
      return Formatter.formatNumber(value);
    },
    getTotalArea() {
      return getSumOfValorFromArray(Object.values(this.coveredAreas));
    },
    getTotalColumn(week, ribbon, option = '') {
      const result = Object.values(
        this.totalColumns[week][ribbon.color_name]
      ).map((totalColumn) =>
        Array.isArray(totalColumn)
          ? getSumOfValorFromArray(totalColumn)
          : totalColumn
      );

      let sum = getSumOfValorFromArray(result);
      if (option === 'byLotsHa') {
        const area = this.getTotalArea();
        sum = Number(area) > 0 ? sum / area : 0;
      }

      return sum > 0 ? Formatter.formatNumber(sum) : 0;
    },
  },
};
</script>
